import React from "react";

/** Full-width horizontal divider, spans from outer vertical lines */
export function FullDivider() {
  return (
    <div
      className="h-px bg-grey-800"
      style={{ width: "100vw", marginLeft: "calc(-50vw + 50%)" }}
    />
  );
}

/**
 * SubPage layout, boxy hero with large title, subtitle, and full-width divider.
 * Horizontal dividers extend to outer vertical lines (beyond the 900px container).
 */
export function SubPage({
  title,
  subtitle,
  logo,
  invertLogo,
  heroImage,
  heroObjectPositionMobile = "15% center",
  children,
}: {
  title: string;
  subtitle?: string;
  logo?: string;
  invertLogo?: boolean;
  heroImage?: string;
  heroObjectPositionMobile?: string;
  children: React.ReactNode;
}) {
  return (
    <div data-subpage>
      {/* Hero */}
      <div
        className="relative flex flex-col justify-end"
        style={heroImage ? { minHeight: "80vh" } : undefined}
      >
        {heroImage && (
          <div
            className="absolute inset-y-0 overflow-hidden pointer-events-none"
            style={{ width: "100vw", left: "calc(-50vw + 50%)" }}
          >
            <img
              src={heroImage}
              alt=""
              className="absolute inset-0 w-full h-full object-cover"
              style={{ objectPosition: heroObjectPositionMobile }}
            />
            <div
              className="absolute inset-0 pointer-events-none"
              style={{
                background:
                  "linear-gradient(to right, rgba(22,23,28,0.92) 0%, rgba(22,23,28,0.78) 45%, rgba(22,23,28,0.55) 100%)",
              }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-grey-975 via-grey-975/60 to-transparent" />
          </div>
        )}
        <div className={`relative px-5 sm:px-8 md:px-[66px] pb-12 md:pb-16 ${heroImage ? "pt-48 sm:pt-56 md:pt-72" : "pt-28 sm:pt-32 md:pt-36"}`}>
          {logo ? (
            <img src={logo} alt={title} className={`h-12 sm:h-16 md:h-20 w-auto object-contain mb-6${invertLogo ? " invert" : ""}`} />
          ) : (
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white tracking-tight mb-6 max-w-2xl leading-none">
              {title}
            </h1>
          )}
          {subtitle && (
            <p className="text-grey-400 max-w-md text-sm leading-relaxed">{subtitle}</p>
          )}
        </div>
      </div>

      {/* Full-width divider after hero */}
      <FullDivider />

      {/* Content */}
      {children}
    </div>
  );
}
